import type { DarkVariant, LightVariant } from "@/lib/theme";

export const DARK_PREVIEW: Record<DarkVariant, { bg: string; card: string; accent: string }> = {
  teal: { bg: "#040f15", card: "#101d23", accent: "#cc9c3c" },
  blue: { bg: "#060e18", card: "#131b26", accent: "#cc9c3c" },
  purple: { bg: "#0f0a18", card: "#1d1727", accent: "#cc9c3c" },
};

export const LIGHT_PREVIEW: Record<LightVariant, { bg: string; card: string; accent: string }> = {
  neutral: { bg: "#ffffff", card: "#f5f5f5", accent: "#a77800" },
  warm: { bg: "#ffffff", card: "#f9f4ec", accent: "#8a5c00" },
  cool: { bg: "#ffffff", card: "#ecf7fa", accent: "#00648a" },
};
